export class BottomNavbarCenterMenu {
  /**
   * @virtual
   */
  static selector() {
    return $('#world-button-nav__default')
  }

  static template() {
    return `
      <div class="world-bottom-nav-inner-wrapper">
        <section class="world-bottom-nav__area world-bottom-nav__center_area">
          <!-- Your content here-->
        </section>
      </div>
    `
  }

  static attach(template) {
    if (!template) {
      template = this.template()
    }
    $('#world-button-nav__default').after(template)
  }

  static hideAllBottomNavMenu() {
    $('.world-bottom-nav__center_area').hide();
  }

  static hide() {
    this.selector().hide()
    $('#world-button-nav__default').show()
  }

  static show() {
    this.hideAllBottomNavMenu()
    this.selector().show()
  }
}

export class BottomNavbarRightMenu extends BottomNavbarCenterMenu {
  static selector() {
    return $('#world-button-nav__default-right')
  }

  static template() {
    return `
      <div class="world-bottom-nav-inner-wrapper">
        <section class="world-bottom-nav__area world-bottom-nav__right_area">
          <!-- Your content here-->
        </section>
      </div>
    `
  }

  static attach(template) {
    if (!template) {
      template = this.template()
    }
    $('#world-button-nav__default-right').after(template)
  }

  static hideAllBottomNavMenu() {
    $('.world-bottom-nav__right_area').hide();
  }

  static hide() {
    this.selector().hide()
    $('#world-button-nav__default-right').show()
  }
}
